<template>
  <span class="medium-text" @click="$emit('click')"><slot></slot></span>
</template>

<script>
export default {
  name: 'MediumText'
}
</script>

<style lang="scss" scoped>
.medium-text {
  font-size: 1.15rem;
}
</style>
